"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFetch = void 0;
var react_1 = require("react");
var useAsyncAction_1 = require("./useAsyncAction");
var DEFAULT_FETCH_DEBOUNCE_TIME = 200;
var DEFAULT_SUSPENSE_DEBOUNCE_TIME = 1000;
var useFetch = function (fetchDelegate, fetchOptions) {
    var _a;
    var _b = react_1.useState(), lastArgs = _b[0], setLastArgs = _b[1];
    var _c = react_1.useState(false), fetched = _c[0], setFetched = _c[1];
    var _d = useAsyncAction_1.useAsyncAction((_a = fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.fetchDebounceLength) !== null && _a !== void 0 ? _a : DEFAULT_FETCH_DEBOUNCE_TIME), trigger = _d.trigger, state = _d.state, result = _d.result, reset = _d.reset;
    var _e = react_1.useState(false), debouncedSlow = _e[0], setDebouncedSlow = _e[1];
    var fetch = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return __awaiter(void 0, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        resetFetchState();
                        setLastArgs(args);
                        return [4 /*yield*/, trigger.apply(void 0, __spreadArray([fetchDelegate], args))];
                    case 1:
                        result = _a.sent();
                        setFetched(true);
                        return [2 /*return*/, result];
                }
            });
        });
    };
    var resetFetchState = function () {
        if (!(fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.preservePreviousItemDuringFetch)) {
            setFetched(false);
            setLastArgs(undefined);
        }
        reset(!(fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.preservePreviousItemDuringFetch));
    };
    var refetch = function () {
        return fetch(lastArgs);
    };
    var timeoutRef = react_1.useRef();
    react_1.useEffect(function () {
        var _a;
        if (state.slow) {
            setDebouncedSlow(true);
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
            console.log('timer started');
            timeoutRef.current = setTimeout(function () {
                setDebouncedSlow(false);
            }, (_a = fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.suspenseDebounceLength) !== null && _a !== void 0 ? _a : DEFAULT_SUSPENSE_DEBOUNCE_TIME);
        }
    }, [state.slow]);
    // FIXME conditional hook use. Put condition inside effect. See rule 1: https://reactjs.org/docs/hooks-rules.html
    if ((fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.autoFetch) === undefined || (fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.autoFetch)) {
        react_1.useEffect(function () {
            fetch.apply(void 0, fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.autoFetchArguments);
        }, []);
    }
    return {
        item: result !== null && result !== void 0 ? result : fetchOptions === null || fetchOptions === void 0 ? void 0 : fetchOptions.initialValue,
        fetched: fetched,
        fetching: state.triggered,
        fetchingSlowly: state.slow,
        fetchingSlowlyDebounced: state.slow || debouncedSlow,
        fetch: fetch,
        refetch: refetch,
        reset: resetFetchState,
    };
};
exports.useFetch = useFetch;
//# sourceMappingURL=useFetch.js.map